import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { SettingsService } from '@cm/core/settings';
import { Observable, map, of, switchMap } from 'rxjs';
import { CmRouteGuard } from '../models';
import { CmAuthService } from '../services';

@Injectable({
	providedIn: 'root',
})
export class AuthRedirectGuard extends CmRouteGuard {
	constructor(
		private readonly auth: CmAuthService,
		private readonly settings: SettingsService,
		private readonly router: Router
	) {
		super();
	}

	canActivate(route: ActivatedRouteSnapshot): Observable<UrlTree | boolean> {
		return this.auth.token$.pipe(
			switchMap(token =>
				!token
					? of(this.router.createUrlTree(this.settings.routeWithContext(['login'])))
					: this.checkAuthGuard$(route)
			)
		);
	}

	private checkAuthGuard$(route: ActivatedRouteSnapshot) {
		const path = route.routeConfig.data?.redirectOnAuthFail
			? route.routeConfig.data.redirectOnAuthFail
			: ['access-denied'];

		return this.auth.guard$.pipe(
			map(guard =>
				this.passesGuardCheck(guard, route.routeConfig.data)
					? true
					: this.router.createUrlTree(this.settings.routeWithContext(path))
			)
		);
	}
}
